import './assets/main.css'

import * as Sentry from "@sentry/vue";
import {browserTracingIntegration, createSentryPiniaPlugin, replayIntegration} from "@sentry/vue";
import {createApp} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'
import Package from '../package.json'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
const ENV = import.meta.env.VITE_ENV
const mode = import.meta.env.MODE

const pinia = createPinia()
const app = createApp(App)

pinia.use(createSentryPiniaPlugin({
  attachPiniaState: false,
}));

app.use(router)
app.use(pinia)

Sentry.init({
  app,
  dsn: SENTRY_DSN,
  integrations: [
    browserTracingIntegration({router, routeLabel: "path"}),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  environment: ENV || 'develop',
  enabled: mode !== 'development',
  release: Package.version
});

app.mount('#app')
